import { jsx } from "react/jsx-runtime";
import AntDivider from "antd/es/divider";
import classnames from "../../utils/classnames.js";
import './Divider.css';/* empty css             */
const Divider = ({
  className,
  children,
  width = "thin",
  color = "light",
  curved = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntDivider,
    {
      className: classnames(
        [
          "perxis-auto-divider",
          `perxis-auto-divider--${width}`,
          `perxis-auto-divider--${color}`,
          { "perxis-auto-divider--curved": curved }
        ],
        className
      ),
      ...props,
      children
    }
  );
};
export {
  Divider as default
};
//# sourceMappingURL=Divider.js.map
